import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useAppSelector } from 'app/hooks';
import IconExport from 'assets/icons/ic_export_gray.svg';
import { SelectField } from 'components/FormFields';
import { CustomIcon } from 'components/ITVSearch';
import { selectConfiguration } from 'features/configuration/configurationSlice';
import { HeaderRemove } from 'features/masterData/Department/styled';

const StyledForm = styled.form`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const StyledWrapperObjectId = styled.div`
  width: 150px;
  .ant-select-selector {
    background-color: #f6f6f6 !important;
  }
  .ant-select-selection-item {
    color: #1a2b88 !important;
    font-weight: bold !important;
    font-size: 12px !important;
  }
`;

interface SelectOption {
  label: string;
  value: string;
}

export interface HeadcountWorkingTimePayload {
  locationId: string;
}

interface HeadcountLineFiltersProps {
  onSubmit?: (payload: Partial<HeadcountWorkingTimePayload>) => void;
  handleExport?: (value: { label: string; value: string }) => void;
  loadingExport?: boolean;
  initialValues?: Partial<HeadcountWorkingTimePayload>;
}

export default function HeadcountWorkingTimeFilters({
  onSubmit,
  handleExport,
  loadingExport = false,
  initialValues,
}: HeadcountLineFiltersProps) {
  const { t } = useTranslation(['dashboard', 'action']);
  const dataConfiguration = useAppSelector(selectConfiguration);

  const IconExportComponents = (
    <CustomIcon type={'export'} component={() => <img src={IconExport} alt="" />} />
  );

  const [isLoading, setIsLoading] = useState(false);
  const [locationOptions, setLocationOptions] = useState<Array<SelectOption>>([]);

  const { control, handleSubmit, getValues, setValue } = useForm<HeadcountWorkingTimePayload>({
    defaultValues: initialValues,
  });

  useEffect(() => {
    async function fetchSubViewBy() {
      try {
        setIsLoading(true);
        const options = dataConfiguration.dataLocation.map((x: any) => ({
          label: x.label,
          value: String(x.id),
        }));

        options.unshift({
          label: `${t('dashboard:dashboard_employee.all_locations')}`,
          value: '0',
        });

        if (options[0].value) {
          setValue('locationId', options[0].value);
        }

        setLocationOptions(options);

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }

    fetchSubViewBy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataConfiguration.dataLocation]);

  const handleFiltersSubmit = (formValues: HeadcountWorkingTimePayload) => {
    onSubmit?.({ ...formValues });
  };

  const handleExportLine = () => {
    const locationId = getValues('locationId');
    const selectedLocation = locationOptions.filter(
      (item: { value: string; label: string }) => item.value === locationId,
    );
    handleExport?.(selectedLocation[0]);
  };

  return (
    <StyledForm onSubmit={handleSubmit(handleFiltersSubmit)}>
      <StyledContainer>
        <StyledWrapperObjectId>
          <SelectField
            name="locationId"
            control={control}
            options={locationOptions}
            defaultValue={'0'}
            showSearch
            allowClear={false}
            loading={isLoading}
            onChange={handleSubmit(handleFiltersSubmit)}
          />
        </StyledWrapperObjectId>

        <HeaderRemove
          onClick={handleExportLine}
          icon={IconExportComponents}
          loading={loadingExport}
          style={{
            backgroundColor: '#f6f6f6',
            fontSize: '12px',
            color: '#1a2b88',
            fontWeight: 'bold',
          }}
        >
          {t('action:export')}
        </HeaderRemove>
      </StyledContainer>
    </StyledForm>
  );
}
